export class Primary {
  constructor() {
   this.name = 'Primary'
   this.content = {
    hasButtons: true,
    hasDots: true,
    hasInterval: false,
    interval: 1000
   }
   this.view = this.viewHtml()
  }

  viewHtml() {
    return `<div>primary</div>`
  }

  dotsClasses() {
    return [
      {property: 'CarouselDots', value: 'DOTS_ROUNDED'},
      {property: 'BorderStyle', value: 'BORDER_SOLID'},
      {property: 'BorderSideTopWidth', value: 'BORDER_TOP_THIN'},
      {property: 'BorderSideBottomWidth', value: 'BORDER_BOTTOM_THIN'},
      {property: 'BorderSideLeftWidth', value: 'BORDER_LEFT_THIN'},
      {property: 'BorderSideRightWidth', value: 'BORDER_RIGHT_THIN'},
    ]
  }

  activeDotStyles() {
    return [
      {property:'BackgroundColor', styleProperty: 'background-image', value: 'linear-gradient(0deg, #000000,#000000)'},
    ]
  }

  dotsStyles() {
    return [
      {property:'BorderColor', styleProperty: 'border-color', value: '#000000'}
    ]
  }

  buttonsClasses() {
    return []
  }

  buttonsStyles() {
    return []
  }

  classes() {
    return []
  }

  styles() {
    return []
  }

  buildData() {
    return {
      name: this.name,
      view: this.view,
    }
  }

  editorProperties() {
    return {
      content: this.content,
      buttonsClasses: {
        desktop: this.buttonsClasses(),
        tablet: this.buttonsClasses(),
        phone: this.buttonsClasses(),
      },
      buttonsStyles: {
        desktop: this.buttonsStyles(),
        tablet: this.buttonsStyles(),
        phone: this.buttonsStyles(),
      },
      dotsClasses: {
        desktop: this.dotsClasses(),
        tablet: this.dotsClasses(),
        phone: this.dotsClasses(),
      },
      dotsStyles: {
        desktop: this.dotsStyles(),
        tablet: this.dotsStyles(),
        phone: this.dotsStyles(),
      },
      activeDotStyles: {
        desktop: this.activeDotStyles(),
        tablet: this.activeDotStyles(),
        phone: this.activeDotStyles(),
      },
      classes: {
        desktop: this.classes(),
        tablet: this.classes(),
        phone: this.classes()
      },
      styles: {
        desktop: this.styles(),
        tablet: this.styles(),
        phone: this.styles()
      },
    }
  }
}